module.exports = __webpack_public_path__ + "static/img/ent-detail-28.345b853.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-28.jpg
// module id = e+nI
// module chunks = 52